import type { FaireProductEntity } from "../../entity_types/product";

export const p_fcmj6583j9: FaireProductEntity = {
  token: "p_fcmj6583j9",
  type: "product",
  name: "Minnesota State Shape Lady Slipper 3 Layer Wood Ornament",
  brandName: "Token Atelier",
  imageUrl:
    "https://cdn.faire.com/fastly/ca4c80b8ba354a6783a07738048569734ee9010c739d7546eed18eec6de399dc.png",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/03d3ee1fb5f434e6df17e7dc1c736a1495b095d51c2a1be7cbc7853a2ab739fc.webp",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
